import {
  LOTTERY_PRIZE_DATA_REQUEST,
  LOTTERY_PRIZE_DATA_SUCCESS,
  LOTTERY_PRIZE_DATA_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOTTERY_PRIZE_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LOTTERY_PRIZE_DATA_SUCCESS: {
      const { prizeInfoResponse = [] } = action.payload;
      return {
        data: prizeInfoResponse,
        isLoading: false,
        error: null
      };
    }
    case LOTTERY_PRIZE_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
